import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const people = {
  global,
  path: paths.people,
  pathname: pathnames[paths.people],
  content: {
    sections: [
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },
    ]
  }
};
